// extracted by mini-css-extract-plugin
export default {"overlay":"overlay_overlay__pnro1","visible":"overlay_visible__Lx1Rg"};